import { useState } from 'react';
import CustomerSatisfactionData from './CustomerSatisfactionData';

const useCustomerSatisfactionData = () => {
  const [ customerSatisfactionState, setCustomerSatisfactionState ] = useState(CustomerSatisfactionData.INITIAL_STATE);

  const postCustomerSatisfaction = (customerSatisfactionObj) => {
    return CustomerSatisfactionData.postCustomerSatisfactionData(customerSatisfactionObj, customerSatisfactionState, setCustomerSatisfactionState);
  };

  const putCustomerSatisfaction = (customerSatisfactionId, customerSatisfactionObj) => {
    return CustomerSatisfactionData.putCustomerSatisfactionData(customerSatisfactionId, customerSatisfactionObj, customerSatisfactionState, setCustomerSatisfactionState);
  };

  return {
    customerSatisfactionState,
    postCustomerSatisfaction,
    putCustomerSatisfaction
  }
}

export default useCustomerSatisfactionData;



